import { createSelector } from 'reselect';

import { getListingsBenchmarkReducer } from '../selectors';
/**
 * @description time division filters
 */
export const selectSelectedListingsBenchmarkTimeDivisionFilter = createSelector(
  [getListingsBenchmarkReducer],
  ({ selectedTimeDivisionFilter }) => selectedTimeDivisionFilter,
);
